<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">
    <slot slot="activator">Link</slot>
    <v-card>
      <v-toolbar>
        <v-btn icon @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dTitle}}</v-toolbar-title>
      </v-toolbar>
      <div v-html="content"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      content: '<p><br>Loading...</p>'
    }
  },

  props: {
    contentUrl: String,
    dTitle: String
  },

  watch: {
    dialog: function (opened) {
      if (opened === true) {
        this.content = `<iframe src="${this.contentUrl}"></iframe>`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// dialog-loader.vue?56ef6dc7